export enum FaizTuruLabel {
    "Yasal Faiz" = 1,
    "Avans Faizi (3095 S.lı Kanun Uyarınca)",
    "İskonto Faizi",
    "USD - M.B. (Kamu Bankalarınca Uygulanacağı Bildirilen) Azami Faiz",
    "Euro - M.B. Bankalarca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "Euro - M.B. Kamu Bankalarınca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "Euro - M.B. (Kamu Bankalarınca Uygulanacağı Bildirilen) Azami Faiz",
    "Gecikme Zammı Oranları",
    "M.B. Azami Mevduat Faizi",
    "TL - M.B. Bankalarca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "TL - M.B. Kamu Bankalarınca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "USD - M.B. Bankalarca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "USD - M.B. Kamu Bankalarınca Mevduatlara Fiilen Uygulanan Azami Faiz",
    "Avans Faizi (Resmi Gazetede Yayınlandığı Gün Uygulanan)",
    "TTK Md. 1530/7 Uyarınca Belirlenen Faiz",
}